import Nullstack from 'nullstack';
export default function IconBrandGooglePodcasts({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-google-podcasts",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M8 17v2"
  }), "   ", Nullstack.element("path", {
    d: "M4 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M20 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M8 5v8"
  }), "   ", Nullstack.element("path", {
    d: "M16 7v-2"
  }), "   ", Nullstack.element("path", {
    d: "M16 19v-8"
  }), " ");
}